import { render, staticRenderFns } from "./LibTableSpecialty2.vue?vue&type=template&id=13259bda&scoped=true"
import script from "./LibTableSpecialty2.vue?vue&type=script&lang=js"
export * from "./LibTableSpecialty2.vue?vue&type=script&lang=js"
import style0 from "./LibTableSpecialty2.vue?vue&type=style&index=0&id=13259bda&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13259bda",
  null
  
)

export default component.exports